{
  "PAGINATION_FOOTER": {
    "SHOWING": "Showing {startItem} - {endItem} of {totalItems} items",
    "CURRENT_PAGE_INFO": "{currentPage} of {totalPages} pages"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "Select an option...",
    "EMPTY_SEARCH_RESULTS": "No items found for the search term `{searchTerm}`",
    "EMPTY_STATE": "No results found.",
    "SEARCH_PLACEHOLDER": "Search...",
    "MORE": "+{count} more"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "Search...",
    "EMPTY_STATE": "No results found.",
    "SEARCHING": "Searching..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "रद्द करें",
      "CONFIRM": "Confirm"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "Search country",
    "ERROR": "Phone number should be empty or in E.164 format",
    "DIAL_CODE_ERROR": "Please select a dial code from the list"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Author is not available"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "Breadcrumb"
  },
  "SWITCH": {
    "TOGGLE": "Toggle switch"
  },
  "LABEL": {
    "TAG_BUTTON": "tag"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "Learn more",
    "WATCH_VIDEO": "Watch video"
  },
  "DURATION_INPUT": {
    "MINUTES": "Minutes",
    "HOURS": "Hours",
    "DAYS": "Days",
    "PLACEHOLDER": "Enter duration"
  },
  "CHANNEL_SELECTOR": {
    "COMING_SOON": "Coming Soon!"
  },
  "SLASH_COMMANDS": {
    "HEADING_1": "Heading 1",
    "HEADING_2": "Heading 2",
    "HEADING_3": "Heading 3",
    "BOLD": "Bold",
    "ITALIC": "Italic",
    "STRIKETHROUGH": "Strikethrough",
    "CODE": "Code",
    "BULLET_LIST": "Bullet List",
    "ORDERED_LIST": "Ordered List",
    "TABLE": "Table",
    "IMAGE": "Image"
  }
}
